export default class CrispHelper {
  static isCrispReady() {
    return !(typeof window.$crisp === 'undefined' || typeof window.$crisp.push !== 'function');
  }

  static openChat() {
    if (!CrispHelper.isCrispReady()) {
      return;
    }

    window.$crisp.push([ 'do', 'chat:open' ]);
  }
}
